getScreenTypeByStaticRoute